import Storage from '@/services/Storage';

import {createRouter, createWebHistory} from '@ionic/vue-router';
import {RouteRecordRaw} from 'vue-router';
import checkingRoutes from './checking/checking';
import stocktakeRoutes from './stocktakes/stocktakes';
import pickingRoutes from './picking/picking';
import packingRoutes from './packing/packing';
import receiveRoutes from './warehouse/receive';
import stackRoutes from './warehouse/stack';
import itemsRoutes from './warehouse/items';
import returnsRoutes from './warehouse/returns';
import listRoutes from './lists/routes';
import upliftRoutes from './warehouse/uplifts';

const routes: Array<RouteRecordRaw> = [
    ...checkingRoutes, ...stocktakeRoutes, ...pickingRoutes, ...packingRoutes,
    ...receiveRoutes, ...stackRoutes, ...itemsRoutes, ...returnsRoutes,
    ...listRoutes, ...upliftRoutes,
    {
        name: 'home',
        path: '/',
        component: () => import('@/views/Tab1.vue')
    },
    {
        path: '/alerts',
        component: () => import("@/views/modules/alerts/pages/List.vue"),
    },
    {
        name: 'login',
        path: '/login',
        component: () => import("@/views/Login.vue"),
        meta: {
            guestAllowed: true
        }
    },
    {
        name: 'test.scan',
        path: '/test/scan',
        component: () => import("@/views/test/Scan.vue"),
    },
    {
        name: 'test.camera',
        path: '/test/camera',
        component: () => import("@/views/test/Camera.vue"),
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});




// Kick people to login if they're not authenticated ----------------
// Based on https://router.vuejs.org/guide/advanced/meta.html
const storage = new Storage();
router.beforeEach((to, from, next) => {
    to.matched.some(async record => {
        const user = await storage.get('user');

        if (user && user.api_token) {
            if (to.name === 'login') {
                console.log("user is present, redirecting back to home ... ");
                next({name:'home', force: true});
            } else {
                next();
            }
        } else {
            if (record.meta && record.meta.guestAllowed) {
                console.log("User not logged in, target route allows guests, everything's fine...");
                next();
            } else {
                console.log("Booting user out to /login because they're not authed...");
                next({
                    name: 'login',
                    query: {redirect: to.fullPath}
                });
            }
        }
    });
})

export default router
